export enum PensionFundType {
  SocialSecurity = 1,
  RetirementOrganization = 2,
}

export const PensionFundTypeLabel = new Map<number, string>([
  [PensionFundType.SocialSecurity, "تامین اجتماعی"],
  [PensionFundType.RetirementOrganization, "سازمان بازنشستگی"],
]);
